import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import {
    ShActionItemComponent,
    ShFormLabelComponent,
    ShFormTextInputComponent,
    ShIconModule
} from '@stylehaven/components';

import { RecordModule } from '../record/record.module';
import { ScannerInputComponent } from './components/scanner-input/scanner-input.component';
import { MultipleRecordsScannerContainer } from './container/multiple-records-scanner/multiple-records-scanner.container';
import { RecordScannerContainer } from './container/record-scanner/record-scanner.container';
import { ScanSandbox } from './services/scan.sandbox';
import { ScanItemValidationService } from './services/scan-item-validation.service';

@NgModule({
    declarations: [ScannerInputComponent, RecordScannerContainer, MultipleRecordsScannerContainer],
    imports: [
        CommonModule,
        RecordModule,
        ReactiveFormsModule,
        TranslateModule,
        ShActionItemComponent,
        ShIconModule,
        ShFormTextInputComponent,
        ShFormLabelComponent
    ],
    exports: [ScannerInputComponent, RecordScannerContainer, MultipleRecordsScannerContainer],
    providers: [ScanSandbox, ScanItemValidationService]
})
export class ScanModule {}
export { ScannerInputComponent } from './components/scanner-input/scanner-input.component';
export { MultipleRecordsScannerContainer } from './container/multiple-records-scanner/multiple-records-scanner.container';
export { RecordScannerContainer } from './container/record-scanner/record-scanner.container';
export { ScanItemValidationOptions } from './entities/scan-item-validation-options.entity';
export * from './entities/scan-item.entity';
